var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{class:{
            'required-field': _vm.field.isRequired,
        },attrs:{"label-for":`id_${_vm.field._id}`}},[_c('label',{class:{
                'urdu-label': _vm.urduLabel,
            }},[_vm._v(_vm._s(_vm.field.label))]),_c('div',{staticClass:"form-group custom-datepicker"},[_c('date-picker',{directives:[{name:"validate",rawName:"v-validate",value:({
                    required: _vm.field.isRequired,
                }),expression:"{\n                    required: field.isRequired,\n                }"}],staticClass:"form-control datepicker-js",class:{
                    'is-invalid': _vm.errors.has(_vm.field.label),
                },attrs:{"format":"DD/MM/YYYY","lang":"en","editable":false,"disabled":_vm.loading || _vm.isDisabled || _vm.field.isDisabled,"data-vv-name":_vm.field.label,"end-at":_vm.endAt,"start-at":_vm.startAt,"default-value":_vm.disabledAfter},on:{"input":_vm.onInput},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}),_c('i',{class:[
                    {
                        'disable-input': false,
                    },
                    'icon-calendar',
                ]})],1),(_vm.note)?_c('p',{staticClass:"tax-instruction"},[_c('i',{staticClass:"icon-error_outline"}),_c('span',[_vm._v("\n                "+_vm._s(_vm.note)+"\n            ")])]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }